/** @file The viewport status line: the notice text, its offer button and a dismiss button. */
import type { Translate } from '@pose2d/i18n/types';
import { useStore } from 'zustand';
import { errorText } from '../../shell/i18n/errorText';
import { currentDoc } from '../../stores/currentDoc';
import { docStore } from '../../stores/docStore';
import { offerActions, type OfferDock } from './offerActions';
import { viewportStore } from './viewportStore';

/** Nothing while there is no notice; role=status so screen readers announce it; `dock` goes to the offer action.
 *  The Auto-rig hint of a fresh import is hidden while the project has slots, however they were made. */
export function ViewportNoticeLine({ t, dock }: { t: Translate; dock?: OfferDock }) {
  const notice = useStore(viewportStore, (s) => s.notice);
  const rigged = useStore(docStore, (s) => Object.keys(currentDoc(s)?.slots ?? {}).length > 0);
  if (notice === null || (notice.kind === 'offer' && notice.action === 'autoRig' && rigged)) return null;
  const text = notice.kind === 'error' ? errorText(t, notice.thrown) : t(notice.key, notice.params);
  return (
    <div className="viewport-notice" role="status">
      <span>{text}</span>
      {notice.kind === 'offer' ? <button type="button" onClick={() => { offerActions[notice.action](dock); }}>{t(`viewport.${notice.action}`)}</button> : null}
      <button type="button" onClick={() => { viewportStore.setState({ notice: null }); }}>{t('viewport.dismiss')}</button>
    </div>
  );
}
